'use client';

import * as React from 'react';

export type State = {
  status: 'PLAYING' | 'MUTED';
};

// TODO: Update
export type Action = {
  type: 'PLAY_VIDEO' | 'MUTE_VIDEO';
};

export type VideoContext = {
  state: State;
  dispatch: React.Dispatch<Action>;
};

export const VideoContext = React.createContext<VideoContext | null>(null);
